export default ({
  service,
  request,
  serviceForMock,
  requestForMock,
  tools
}) => ({
  // 游戏数据 
  configurationAll(data = {}) {
    return request({
      url: '/api/configuration/configurationAll',
      method: 'get',
      params: data
    })
  },
  // 获取logo数据
  logoSetDataAll(data = {}) {
    return request({
      url: '/api/configuration/logoSetDataAll',
      method: 'get',
      params: data
    })
  },
  // 获取页脚数据
  copyrightAll(data = {}) {
    return request({
      url: '/api/copyright/copyrightAll',
      method: 'get',
      params: data
    })
  },
  // 隐私政策
  privacyAgreementData(data = {}) {
    return request({
      url: '/api/privacyAgreement/privacyAgreementAll',
      method: 'get',
      params: data
    })
  },
  // 用户协议
  userAgreementAll(data = {}) { 
    return request({
      url: '/api/userAgreement/userAgreementAll',
      method: 'get',
      params: data
    })
  },
  // 联系我们
  contactWayAll(data = {}) {
    return request({
      url: '/api/contactWay/contactWayAll',
      method: 'get',
      params: data
    })
  },
  // 获取充值游戏列表
  paymentGamesSelect(data = {}) {
    return request({
      url: '/api/paymentGames/paymentGamesSelect',
      method: 'get',
      params: data
    })
  },

  // 获取充值商品列表
  paymentProductsAll(data = {}) {
    return request({
      url: '/api/paymentProducts/paymentProductsAll',
      method: 'get',
      params: data
    })
  },
})